import { render } from "./gradeTypeViewCard.vue?vue&type=template&id=5d61dbbf&scoped=true"
import script from "./gradeTypeViewCard.vue?vue&type=script&lang=js"
export * from "./gradeTypeViewCard.vue?vue&type=script&lang=js"

import "./gradeTypeViewCard.vue?vue&type=style&index=0&id=5d61dbbf&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d61dbbf"]])

export default __exports__